/*-- Date picker--*/
$(document).ready( function() {
  $(function() {
    $(".date").datepicker( { 
      minDate: +1,
      maxDate: '+2M',
      beforeShowDay: jQuery.datepicker.noWeekends,
     dateFormat: 'dd-mm-yy'
      //,
// 	 onSelect: function(dateText, inst) { 
//        alert('selected date ' + dateText + ':' + inst) 
//        console.log(('.date').val());
//      }
      
      
    });
  });
});




/*-- math captcha--*/
$(document).ready(function() {
  var n1 = Math.round(Math.random() * 10 + 1);
  var n2 = Math.round(Math.random() * 10 + 1);
  $("#question").val(n1 + " + " + n2);
  $(".appointment_class").submit(function (e) {
    if (eval($("#question").val()) != $("#answer").val()) {
      $("#answer").css('box-shadow', '0px 0px 7px red');
      e.preventDefault(); 
    } 
  });
});
$(document).ready(function() {
  var n1 = Math.round(Math.random() * 10 + 1);
  var n2 = Math.round(Math.random() * 10 + 1);
  $("#question1").val(n1 + " + " + n2);
  $('.enquire_class input[type="submit"]').on('click', function (e) {
    if (eval($("#question1").val()) != $("#answer1").val()) {
      $("#answer1").css('box-shadow', '0px 0px 7px red');
      e.preventDefault(); 
    } else {
      $(this).closest('form').submit();
    }
  });
});
$(document).ready(function() {
  var n01 = Math.round(Math.random() * 10 + 1);
  var n02 = Math.round(Math.random() * 10 + 1);
  $("#question").val(n01 + " + " + n02);
  $('.contact-form input[type="submit"]').on('click', function (e) {
    if (eval($("#question").val()) != $("#answer").val()) {
      $("#answer").css('box-shadow', '0px 0px 7px red');
      e.preventDefault(); 
    } else {
      $(this).closest('form').submit();
    }
  });
});
$(document).ready(function() {
  var n_01 = Math.round(Math.random() * 10 + 1);
  var n_02 = Math.round(Math.random() * 10 + 1);
  $("#question-appointment").val(n_01 + " + " + n_02);
  $('.appointment_form input[type="submit"]').on('click', function (e) {
    if (eval($("#question-appointment").val()) != $("#answer-appointment").val()) {
      e.preventDefault();
      $("#answer-appointment").css('box-shadow', '0px 0px 7px red'); 
    } else {
      $(this).closest('form').submit();
    }
  });
});

$(document).ready(function() {
  var n001 = Math.round(Math.random() * 10 + 1);
  var n002 = Math.round(Math.random() * 10 + 1);
  $("#question-appointment-global").val(n001 + " + " + n002);
  $('.appointment_form_global input[type="submit"]').on('click', function (e) {
    if (eval($("#question-appointment-global").val()) != $("#answer-appointment-global").val()) {
      e.preventDefault();
      $("#answer-appointment-global").css('box-shadow', '0px 0px 7px red'); 
    } else {
      $(this).closest('form').submit();
    }
  });
});

$(document).ready(function() {
  var n0001 = Math.round(Math.random() * 10 + 1);
  var n0002 = Math.round(Math.random() * 10 + 1);
  $("#question-contact-page").val(n0001 + " + " + n0002);
  $('.contact-page-form input[type="submit"]').on('click', function (e) {
    if (eval($("#question-contact-page").val()) != $("#answer-contact-page").val()) {
      e.preventDefault();
      $("#answer-contact-page").css('box-shadow', '0px 0px 7px red'); 
    } else {
      $(this).closest('form').submit();
    }
  });
});

// enquire - appointment form

jQuery(function($){
  var info_to_be_sent = $('.product-info-to-be-sent').html();
  $('.enquire_class').find('.hidden-product-info').val(''+info_to_be_sent);
  $('.appointment_class').find('.hidden-product-info').val(''+info_to_be_sent);
  
//   $('.hidden-product-info').val(''+info_to_be_sent);
 // console.log($('.enquire_class').find('.hidden-product-info').val(''+info_to_be_sent));
  //console.log($('.appointment_class').find('.hidden-product-info').val(''+info_to_be_sent));
  
  if(window.location.href.indexOf('contact_posted=true') > -1){
    //$('.enquire_now').trigger('click');
    $('.enquire_success').trigger('click');
    var newUrl = window.location.href.replace('?contact_posted=true', '');
    window.history.pushState({path:newUrl},'',newUrl);
  }
  //change page video height/width
  $('.rte p .lazyframe iframe').each(function(){
    $(this).css({width: $(this).attr('width') || 'auto', height: $(this).attr('height') || 'auto'});
  });
});



$('.readmore').click(function (event) {
  event.preventDefault();
  $('.product-description-full').fadeIn(5);
  $('.product-description-short').fadeOut(5);
});
$('.readless').click(function (event) {
  event.preventDefault();
  $('.product-description-full').fadeOut(5);
  $('.product-description-short').fadeIn(5);
}); 

jQuery(function($){   
  $(".custom-scrollbar").mCustomScrollbar({
    theme: 'dark'
  });
});



